import { http, URL } from "./http.service";
import { errorHandler } from "./error.service";

export const createProducts = async (businessId, data) => {
  try {
    const result = await http.post(
      `${URL}/inventory/${businessId}/create`,
      data
    );
    return result;
  } catch (error) {
    errorHandler(error);
  }
};

export const getProducts = async (businessId, params = {}) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    const result = await http.get(
      `${URL}/inventory/${businessId}/get-products?${queryString}`
    );
    return result;
  } catch (error) {
    console.log("errror", error);
    errorHandler(error);
  }
};


export const createServices = async (businessId, data) => {
  try {
    const result = await http.post(
      `${URL}/inventory/${businessId}/service-create`,
      data
    );
    return result;
  } catch (error) {
    console.log("errror", error);
    errorHandler(error);
  }
};

export const getServices = async (businessId, params = {}) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    const result = await http.get(
      `${URL}/inventory/${businessId}/get-services?${queryString}`
    );
    return result;
  } catch (error) {
    console.log("errror", error);
    errorHandler(error);
  }
};

export const updateProductService = async (businessId, productId, data) => {
  try {
    const result = await http.put(
      `${URL}/inventory/${businessId}/product/${productId}`,
      data
    );
    return result;
  } catch (error) {
    console.log("errror", error);
    errorHandler(error);
  }
};

export const deleteProductService = async (businessId, productId) => {
  try {
    const result = await http.delete(
      `${URL}/inventory/${businessId}/product/${productId}`
    );
    return result;
  } catch (error) {
    console.log("errror", error);
    errorHandler(error);
  }
};

export const updateServices = async (businessId, serviceId, data) => {
  try {
    const result = await http.put(
      `${URL}/inventory/${businessId}/service/${serviceId}`,
      data
    );
    return result;
  } catch (error) {
    console.log("errror", error);
    errorHandler(error);
  }
};

export const deleteServices = async (businessId, serviceId) => {
  try {
    const result = await http.delete(
      `${URL}/inventory/${businessId}/service/${serviceId}`
    );
    return result;
  } catch (error) {
    console.log("errror", error);
    errorHandler(error);
  }
};

export const bulkUploadproducts = async (businessId, data) => {
  try {
    const result = await http.post(
      `${URL}/inventory/${businessId}/bulk-upload-producs`,
      {
        products: JSON.stringify(data),
      }
    );
    return result;
  } catch (error) {
    console.log("errror", error);
    errorHandler(error);
  }
};

export const bulkUploadproductsWithSupplier = async (businessId, data) => {
  try {
    const result = await http.post(
      `${URL}/inventory/${businessId}/vendor/bulk-upload-products`,
      {
        products: JSON.stringify(data),
      }
    );
    return result;
  } catch (error) {
    console.log("errror", error);
    errorHandler(error);
  }
};

export const bulkUploadpurchaseWithSupplier = async (businessId, data) => {
  try {
    const result = await http.post(
      `${URL}/buy/${businessId}/create-bulk-purchaseWithLogisticsDetails`,
      {
        purchases: JSON.stringify(data),
      }
    );
    return result;
  } catch (error) {
    console.log("errror", error);
    errorHandler(error);
  }
};


export const updateProductsWithAnalytics = async (businessId, productsData) => {
  try {
    console.log("Sending analytics data:", productsData);

    const result = await http.post(
      `${URL}/inventory/${businessId}/update-with-analytics`,
      productsData, // This should be an array of {productId, predictedPrice}
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return result;
  } catch (error) {
    console.log("error", error);
    errorHandler(error);
  }
};



export const getRawmatrial = async (businessId, params = {}) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    const result = await http.get(
      `${URL}/inventory/${businessId}/get-rawmatrial?${queryString}`
    );
    return result;
  } catch (error) {
    console.log("errror", error);
    errorHandler(error);
  }
};


 
// Update raw material service function - FIXED VERSION
export const updateRawMaterialService = async (businessId, rawMaterialId, payload) => {
  try {
    // console.log("🔧 Updating raw material:", {
    //   businessId,
    //   rawMaterialId,
    //   payload,
    // });

    const response = await http.put(
      `${URL}/inventory/${businessId}/rawmaterial/${rawMaterialId}/update`,
      payload
    );

    // console.log("✅ Update successful:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Update failed:", error.response?.data || error.message);
    throw error;
  }
};


// Delete raw material service function - FIXED VERSION  
export const deleteRawMaterialService = async (businessId, rawMaterialId) => {
  try {
    console.log("Service - Delete raw material:", {
      businessId,
      rawMaterialId
    });

    const response = await http.delete(
      `${URL}/inventory/${businessId}/rawmaterial/${rawMaterialId}`,
    );
    
    console.log("Service - Delete response:", response);
    return response;
  } catch (error) {
    console.error("Service - Delete error:", error);
    throw error;
  }
};
export const getVariantOptions = async (businessId, productId) => {
  try {
    const result = await http.get(
      `${URL}/variant/${businessId}/product/${productId}/variant-options`
    );
    return result;
  } catch (error) {
    console.error("Error getting variant options:", error);
    errorHandler(error);
  }
};



export const getProductVariants = async (businessId, productId) => {
  try {
    const result = await http.get(
      `${URL}/variant/${businessId}/product/${productId}/variants`
    );
    return result;
  } catch (error) {
    console.error("Error getting product variants:", error);
    errorHandler(error);
  }
};

// services/inventory.service.js

export const updateVariant = async (businessId, productId, variantId, data) => {
  try {
    const result = await http.put(
      `${URL}/variant/${businessId}/product/${productId}/variant/${variantId}`, // Added /api/
      data
    );
    return result;
  } catch (error) {
    console.error("Error updating variant:", error);
    errorHandler(error);
  }
};

export const deleteVariant = async (businessId, productId, variantId) => {
  try {
    const result = await http.delete(
      `${URL}/variant/${businessId}/product/${productId}/variant/${variantId}`, // Added /api/
    );
    return result;
  } catch (error) {
    console.error("Error deleting variant:", error);
    errorHandler(error);
  }
};

export const pushProductToMetaService = async (businessId, productId) => {
  try {
    const result = await http.post(
      `${URL}/inventory/${businessId}/product/${productId}/push-to-meta`
    );
    return result;
  } catch (error) {
    console.error("Error pushing product to Meta:", error);
    errorHandler(error);
  }
};

export const pushProductsToMetaService = async (businessId, productIds = []) => {
  try {
    const payload = Array.isArray(productIds) && productIds.length > 0 ? { productIds } : {};
    const result = await http.post(
      `${URL}/inventory/${businessId}/push-products-to-meta`,
      payload
    );
    return result;
  } catch (error) {
    console.error("Error pushing products to Meta:", error);
    errorHandler(error);
  }
};
export const updateBusinessServiceTimings = async (businessId, data) => {
  try {
    const result = await http.put(
      `${URL}/inventory/${businessId}/service-shared-settings`,
      data
    );
    return result;
  } catch (error) {
    console.log("errror", error);
    errorHandler(error);
    throw error;
  }
};

export const saveProductVariants = async (businessId, productId, data) => {
  try {
    const result = await http.post(
      `${URL}/variant/${businessId}/product/${productId}/save-variants`, // Added /api/
      data
    );
    return result;
  } catch (error) {
    console.error("Error saving variants:", error);
    errorHandler(error);
  }
};